import first from "lodash/first";
import { graphql, readInlineData } from "react-relay";

import { article as articleData } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import type { helpersExpertPerspectiveArticle$key } from "scmp-app/queries/__generated__/helpersExpertPerspectiveArticle.graphql";

export const isExpertPerspectiveArticle = (
  reference?: helpersExpertPerspectiveArticle$key | null,
) => {
  const article = readInlineData(
    graphql`
      fragment helpersExpertPerspectiveArticle on Article @inline {
        types {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );
  if (!notEmpty(article?.types)) return false;

  const typeIds =
    article.types
      ?.flatMap(type => type?.value)
      ?.map(type => type?.entityId ?? "")
      ?.filter(notEmpty) ?? [];
  const firstTypeId = first(typeIds);

  return (
    articleData.types.opinion.entityId === firstTypeId ||
    articleData.types.column.entityId === firstTypeId
  );
};
